// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-select-disabled>.ant-select-selector, .ant-input-disabled{
    background: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/claims/components/style/transaction-adjustment-modal.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC","sourcesContent":[".ant-select-disabled>.ant-select-selector, .ant-input-disabled{\n    background: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
